export const messages = {
    
    en: {
        home: {
            header: 'Welcome to Hotel Botnia!'
        }
    },
    sv:{
        home: {
            header: 'Välkommen till Hotel Botnia!'
        },
        article:{
            allergens: '<span>Allergisk? Prata med oss i restaurangen.</span>'
        },
        shopSelector: {
            singleShop: {
                start: "Beställ här",
                closed: "Stängt",
                paused: "Stängt för beställning",
                openingHoursHeader: "Dagens öppettider",
            }
        },
    },
    fi:{},
    no:{},
    ru:{}
}